var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardtracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.2285714 4.8h-3.7142857c-.4-1.04516129-1.3714286-1.8-2.5142857-1.8s-2.11428571.75483871-2.51428571 1.8h-3.71428572c-.97142857 0-1.77142857.81290323-1.77142857 1.8v12.6c0 .9870968.8 1.8 1.77142857 1.8h12.45714283c.9714286 0 1.7714286-.8129032 1.7714286-1.8v-12.6c0-.98709677-.8-1.8-1.7714286-1.8zm-6.2285714 0c.5142857 0 .9142857.40645161.9142857.87096774s-.4.92903226-.9142857.92903226-.9142857-.40645161-.9142857-.92903226c0-.52258064.4-.87096774.9142857-.87096774zm-4.45714286 3.6h8.91428576v-1.8h1.7714285v12.6h-12.45714283v-12.6h1.77142857zm2.68571426 8.1290323h-1.77142854v-4.5290323h-1.77142857l2.68571428-2.67096774 2.68571433 2.67096774h-1.7714286v4.5290323zm3.5428572-5.4h1.7714285v4.5290322h1.7714286l-2.6857143 2.6709678-2.6285714-2.7290323h1.7714286z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardtracking);
export default __webpack_public_path__ + "static/media/clipboard tracking.04abda5213254d37881d5ca7d2f9a67f.svg";
export { ForwardRef as ReactComponent };